import { action, observable } from 'mobx';
import axios from 'axios';

let obx = observable({
  feature: null,
  help: null,
  helpLoaded: false,
  getHelp: action(function(){
    if(!obx.helpLoaded) {
      const timestamp = (new Date()).getTime();

      axios.get(`https://raw.githubusercontent.com/SmarterServices/smarterproctoring-docs/master/docs.json?t=${timestamp}`)
        .then(response => {
          obx.help = response.data;
          obx.helpLoaded = true;
        });
    }
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/HelpStore.js